import React from "react";
import AllSubjectTopics from "../../topics/AllSubjectTopics";


function ToperNoteBioTopics() {
  return (
    <>

      <AllSubjectTopics  subject="biology" type="topernote" />

    </>
  );
}

export default ToperNoteBioTopics;